import * as React from "react";
import {
  CalendarClock, MessageSquare, Columns3, ClipboardList, UserCog,
  Wallet, BookOpen, Sparkles, FolderOpen, Inbox, ShieldAlert,
  Grid3x3, Building2, LayoutDashboard, Users,
} from "lucide-react";

/**
 * One refined glyph disc per module in its accent tone on a soft card.
 * Used in module headers, wall panes, marketing tiles.
 *
 * <ModuleMark id="cases" size={40} />
 */

const REGISTRY = {
  bookings: { icon: CalendarClock, tint: "violet" },
  comms:    { icon: MessageSquare, tint: "violet" },
  boards:   { icon: Columns3,      tint: "violet" },
  rotas:    { icon: ClipboardList, tint: "violet" },
  hr:       { icon: UserCog,       tint: "violet" },
  pay:      { icon: Wallet,        tint: "emerald" },
  books:    { icon: BookOpen,      tint: "amber" },
  plus:     { icon: Sparkles,      tint: "teal" },
  cases:    { icon: FolderOpen,    tint: "violet" },
  queue:    { icon: Inbox,         tint: "amber" },
  alerts:   { icon: ShieldAlert,   tint: "coral" },
  wall:     { icon: Grid3x3,       tint: "violet" },
  org:      { icon: Building2,     tint: "violet" },
  dashboard:{ icon: LayoutDashboard, tint: "violet" },
  members:  { icon: Users,         tint: "violet" },
};

const TINT_STYLES = {
  violet:  { bg: "#EDE9FE", fg: "#6E3CFA" },
  emerald: { bg: "#D1FAE5", fg: "#047857" },
  amber:   { bg: "#FEF3C7", fg: "#92400E" },
  coral:   { bg: "#FEE2E2", fg: "#B91C1C" },
  teal:    { bg: "#CCFBF1", fg: "#0F766E" },
};

export default function ModuleMark({
  id = "bookings", size = 32, className = "", title, testId,
}) {
  const meta = REGISTRY[id] || { icon: Sparkles, tint: "violet" };
  const Icon = meta.icon;
  const tint = TINT_STYLES[meta.tint] || TINT_STYLES.violet;
  const iconSize = Math.max(12, Math.round(size * 0.48));
  const radius = Math.max(6, Math.round(size * 0.26));
  return (
    <div
      className={`inline-flex items-center justify-center shrink-0 ${className}`}
      style={{
        width: size, height: size, borderRadius: radius,
        background: tint.bg, color: tint.fg,
        boxShadow: "0 1px 2px rgba(0,0,0,0.04), inset 0 1px 0 rgba(255,255,255,0.6)",
      }}
      role="img"
      aria-label={title || `${id} module mark`}
      title={title}
      data-testid={testId || `module-mark-${id}`}
    >
      <Icon size={iconSize} strokeWidth={1.75} />
    </div>
  );
}
